/**
 * Biodiversity site proximity options.
 *
 * Used for VSME B5 – Biodiversity to indicate whether a site is
 * located "in" or "near" a biodiversity-sensitive area.
 */

/** Proximity codes mapped to Norwegian names. */
export const biodiversitySiteProximityNb: Record<string, string> = {
  in: "I",
  near: "Nær",
}

/** Sorted array of { code, name } for use in dropdowns. */
export const biodiversitySiteProximityOptionsNb: Array<{ code: string; name: string }> = Object.entries(
  biodiversitySiteProximityNb,
)
  .map(([code, name]) => ({ code, name }))
  .sort((a, b) => a.name.localeCompare(b.name, "nb"))
